import React, { Suspense } from "react";
const SboUploadPageWrapper = React.lazy(() => import("../components/SboUploadPageWrapper"));

function SboPage() {
  return (
    <Suspense
      fallback={
        <>
          Loading...
        </>
      }
    >
      <SboUploadPageWrapper />
    </Suspense>
  );
}

export default SboPage;
